module.exports = __webpack_public_path__ + "static/media/tr15.88712dea.png";